import { useState, useEffect } from 'react';
import { message } from 'antd';
import { getAgents } from '../MessagesServices';

const useAgents = () => {
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [loadingAgents, setLoadingAgents] = useState(false);

    const fetchAgents = async (search = '') => {
        setLoadingAgents(true);
        try {
            const { data } = await getAgents({
                page: 1,
                size: 100,
                search: search
            });
            setAgents(data);
            if (data.length > 0 && !selectedAgent) {
                setSelectedAgent(data[0].id);
            }
        } catch (error) {
            message.error(error.response?.data?.message || 'Failed to load agents');
        } finally {
            setLoadingAgents(false);
        }
    };

    useEffect(() => {
        fetchAgents();
    }, []);

    return {
        agents,
        selectedAgent,
        loadingAgents,
        setSelectedAgent,
        fetchAgents
    };
};

export default useAgents;